'use client';
import { ViewMode } from '@/features/gfWorks/types';
import type { ViewModeType } from '@/features/gfWorks/types';
import type { GfWork } from '@/types';
import { useMemo, useState } from 'react';
import WorkCardList from '../WorkCardList/WorkCardList';
import WorkList from '../WorkList/WorkList';
import WorksPageHeader from '../WorksPageHeader/WorksPageHeader';
import styles from './WorksListContainer.module.scss';

function WorksListContainer({
  initialWorks,
  selectedProductId,
  selectedProductImagePath,
}: {
  initialWorks: GfWork[];
  selectedProductId?: number;
  selectedProductImagePath?: string;
}) {
  const [viewMode, setViewMode] = useState<ViewModeType>(ViewMode.tile.value);

  //ビューモード変更時の処理
  const handleViewModeChange = (newViewMode: ViewModeType) => {
    setViewMode(newViewMode);
  };

  const workLinkInfo = useMemo(() => {
    if (!selectedProductId) {
      return { prefix: '/works', params: {} };
    }
    // リンクのプレフィックス決定
    const prefix = '/product-first-select/works';
    // クエリパラメータの生成
    const params: Record<string, string> = {};
    params.productId = selectedProductId.toString();
    return {
      prefix,
      params,
    };
  }, [selectedProductId]);

  //表示コンテンツの判定
  const renderWorksContent = () => {
    if (initialWorks.length === 0) {
      return <p>作品がありません</p>;
    }

    if (viewMode === ViewMode.tile.value) {
      return (
        <WorkCardList works={initialWorks} workLinkPrefix={workLinkInfo.prefix} workLinkParam={workLinkInfo.params} />
      );
    }
    return <WorkList works={initialWorks} workLinkPrefix={workLinkInfo.prefix} workLinkParam={workLinkInfo.params} />;
  };

  //コンテナのクラス名判定
  const getWorksListContainerClassName = () => {
    return selectedProductId ? styles.worksListContainerWithProduct : styles.worksListContainer;
  };

  //表示コンテンツのクラス名判定
  const getContainerClassName = () => {
    const isListMode = viewMode === ViewMode.list.value;
    return `
      ${styles.worksInfoContainer} ${isListMode ? styles.worksInfoContainerList : ''}
    `;
  };

  return (
    <div className={getWorksListContainerClassName()}>
      <WorksPageHeader
        workCount={initialWorks.length}
        currentViewMode={viewMode}
        onViewModeChange={handleViewModeChange}
        selectedProductId={selectedProductId}
        titleProductImagePath={selectedProductImagePath}
      />
      <div className={getContainerClassName()}>{renderWorksContent()}</div>
    </div>
  );
}

export default WorksListContainer;
